import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, Spin } from 'antd';
import { RegisterRepresentCompany } from '../../forms';
import PropTypes from 'prop-types';
import PropTypesImmutable from 'react-immutable-proptypes';
import {
  fetchMandateCompany,
  deleteMandateCompany,
} from '../../actions/actionCreators/registerActionCreators';
import {
  showRegisterRepresentCompanyModal,
  hideRegisterRepresentCompanyModal,
  getRegisterRepresentCompanyModal,
} from '../../actions/actionCreators/modalsActionCreators';
import { getDeleteMandateCompany } from '../../reducers/registerAddMandateReducer';
import {
  getMandateCompanyList,
  getMandateCompanyListPure,
} from '../../reducers/registerReducer';
import MandateCompaniesTable from '../../components/MandateCompaniesTable/MandateCompaniesTable';
import { getLoadingSelector } from '../../utils/asyncHelpers';

export class RegisterManagementCompany extends Component {
  static propTypes = {
    fetchMandateCompany: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    mandateCompanies: PropTypesImmutable.list.isRequired,
    t: PropTypes.func.isRequired,
    showRepresentCompanyModal: PropTypes.func.isRequired,
    hideRepresentCompanyModal: PropTypes.func.isRequired,
  };

  state = {
    editCompanyData: null,
  };

  editRepresentCompany = (data) => {
    this.setState({ editCompanyData: data });
    this.props.showRepresentCompanyModal();
  };

  handleHideCompanyModal = () => {
    this.setState({ editCompanyData: null });
    this.props.hideRepresentCompanyModal();
  };

  componentDidMount() {
    this.props.fetchMandateCompany(this.props.legalEntity.get('id'));
  }

  render() {
    const {
      t,
      isLoading,
      mandateCompanies,
      modalCompanyVisible,
      showRepresentCompanyModal,
      deleteRepresentCompany,
      legalEntity,
    } = this.props;

    return (
      <Spin spinning={isLoading}>
        <div className="register-management-container">
          <h2 className="register-management-container__subtitle">
            {t('representation.subtitleCompanies')}
          </h2>
          <MandateCompaniesTable
            editRepresent={this.editRepresentCompany}
            deleteRepresent={deleteRepresentCompany}
            t={t}
            data={mandateCompanies.toJS()}
          />
          <div className="register-management-container__add-button">
            <Button
              onClick={showRepresentCompanyModal}
              size="large"
              type="primary"
            >
              {t('representation.buttonAddCompanies')}
            </Button>
          </div>
          {modalCompanyVisible && (
            <Modal
              title={t('representation.titleModalCompanies')}
              wrapClassName="register-management-container__modal"
              open={modalCompanyVisible}
              footer={null}
              onCancel={this.handleHideCompanyModal}
              width={640}
            >
              <RegisterRepresentCompany
                closeModal={this.handleHideCompanyModal}
                initialValues={{
                  originatorLegalEntityId: legalEntity.get('id'),
                  ...this.state.editCompanyData,
                }}
                t={t}
              />
            </Modal>
          )}
        </div>
      </Spin>
    );
  }
}

const getLoading = getLoadingSelector(
  getDeleteMandateCompany,
  getMandateCompanyListPure
);

const mapStateToProps = (state) => ({
  isLoading: getLoading(state),
  mandateCompanies: getMandateCompanyList(state),
  modalCompanyVisible: getRegisterRepresentCompanyModal(state),
});

const mapDispatchToProps = {
  deleteRepresentCompany: deleteMandateCompany,
  hideRepresentCompanyModal: hideRegisterRepresentCompanyModal,
  showRepresentCompanyModal: showRegisterRepresentCompanyModal,
  fetchMandateCompany,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterManagementCompany);
